import { PhoneField } from '@components/EditPhone/PhoneField';
import { ArrowBackIos } from '@mui/icons-material';
import { Box, Button, colors, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import formatPhoneNumber from '@utils/formatPhoneNumber';
import { useEditPhoneNumberController } from '@app/pages/Profile/useEditPhoneNumberController';
import { VerifyNewPhoneNumber } from './VerifyNewPhoneNumber';

interface EditPhoneNumberProps {
  open: boolean;
  phoneNumber: string;
}
export const EditPhoneNumber: FC<EditPhoneNumberProps> = (props) => {
  const [searchParams] = useSearchParams();
  const showVerify = searchParams.get('showModal') === 'verify';
  const [phoneNumberValid, setPhoneNumberValid] = React.useState(false);
  const { onPhoneNumberChange, onSendVerificationCode, phoneNumber, error, errorMessage } =
    useEditPhoneNumberController();
  useEffect(() => {
    setPhoneNumberValid(!error);
  }, [error]);
  return (
    <>
      <Dialog open={props.open} fullScreen>
        <DialogTitle sx={{ color: colors.common.black }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
            }}
          >
            <NavLink
              to={''}
              style={{ textDecorationLine: 'none', marginLeft: 1, marginRight: 1, cursor: 'pointer', color: '#05B5FF' }}
            >
              <Box
                sx={{
                  mt: 4,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <ArrowBackIos></ArrowBackIos>
                <Typography
                  component={'span'}
                  sx={{
                    color: '#05B5FF',
                  }}
                >
                  Back
                </Typography>
              </Box>
            </NavLink>
            Notification Settings
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              mb: 2,
              mt: 4,
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: 15,
              }}
            >
              Current Phone Number:
            </Typography>
            <Typography
              color={'textSecondary'}
              sx={{
                fontWeight: 400,
                fontSize: 15,
              }}
            >
              +1 {formatPhoneNumber(props.phoneNumber)}
            </Typography>
          </Box>
          <PhoneField label={'Enter New Phone Number'} onChange={onPhoneNumberChange} phoneNumber={''}></PhoneField>
          <Box
            sx={{
              mt: 4,
            }}
          >
            <Button
              disabled={!phoneNumberValid}
              fullWidth
              variant={'contained'}
              color={'primary'}
              onClick={onSendVerificationCode}
            >
              Send Code
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <VerifyNewPhoneNumber visible={showVerify} number={phoneNumber}></VerifyNewPhoneNumber>
    </>
  );
};
